module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-148.99c31782.svg";